<template>
  <div class="unlock-main" v-loading="nLoading">
    <!-- <div style="background: #fff;">
      <div class="div-tabs">
        <span :class="activeTabs==='first'?'is-tabs':''" @click="clickTabs1('first')">搜索列表</span>
        <span :class="activeTabs==='second'?'is-tabs':''" @click="clickTabs1('second')">短视频列表</span>
      </div>
    </div> -->
    <div v-if="activeTabs==='first'">
      <div class="tabs-head" :style="{padding:(selectWidth == 46 ? '0 24px 10px' : '0 8px 10px')}">
        <div class="div-tabs">
          <span :class="type===1?'is-tabs':''" @click="clickTabs(1)">待我跟进</span>
          <!-- <span :class="type===2?'is-tabs':''" @click="clickTabs(2)">等会再打({{headTotal}})</span> -->
          <span :class="type===3?'is-tabs':''" @click="clickTabs(3)">回收站</span>
        </div>
        <div class="unlock-head">
          <div class="sort-condition">
            <el-row>
              <el-date-picker v-model="date" value-format="yyyy-MM-dd" :picker-options="pickerOptions" unlink-panels range-separator="~" start-placeholder="解锁开始时间" end-placeholder="解锁结束时间"
                type="daterange" size="small" class="mr-16 datePicker" @change="changeUnlockList"></el-date-picker>
              <!-- <span>线索状态：</span> -->
              <el-select v-model="contactStatus" class="mr-16" clearable placeholder="请选择线索状态" size="small" @change="changeUnlockList">
                <el-option label="已转化" :value="1" />
                <el-option label="未转化" :value="0" />
              </el-select>
              <!-- <span>跟进状态：</span> -->
              <el-select v-model="isFollow" class="mr-16" clearable placeholder="跟进状态" size="small" @change="changeUnlockList">
                <el-option label="未跟进" :value="0" />
                <el-option label="已跟进" :value="1" />
              </el-select>

              <el-select v-model="state" class="mr-16" clearable placeholder="号码清洗结果" size="small" @change="changeUnlockList">
                <el-option label="活跃号" :value="1" />
                <el-option label="沉默号" :value="4" />
                <el-option label="风险号" :value="5" />
                <el-option label="空号" :value="0" />
                <el-option label="未检测" :value="100" />
              </el-select>

              <span class="searchBtn">
                <el-input placeholder="请输入企业名称" v-model="companyName" class="input-with-select" size="small" @keyup.enter.native="changeUnlockList" />
                <img src="~@/assets/gbIcon/search_icon.png" @click="changeUnlockList">
              </span>

              <el-button style="margin-left:8px" type="dialog-confirm" size="small" class="ml-16" @click="clickReset">重置</el-button>

            </el-row>
            <el-row style="margin-top:10px" v-show="hideFlag">
              <!-- <span>联系方式类型：</span> -->
              <el-select style="width:180px" v-model="contactSource" class="mr-16 contactType" clearable placeholder="请选择联系方式类型" size="small" @change="changeUnlockList">
                <el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>

              <!-- <span>是否关键联系人：</span> -->
              <el-select v-model="isKeyContact" class="mr-16 isKeyContact" clearable placeholder="是否关键联系人" size="small" @change="changeUnlockList">
                <el-option v-for="item in contact_key_person" :key="item.code" :label="item.name" :value="item.code"></el-option>
              </el-select>

              <!-- <span>是否代理记账：</span> -->
              <el-select v-model="numStatus" class="mr-16 isAgentA" clearable placeholder="是否代理记账" size="small" @change="changeUnlockList">
                <el-option v-for="item in bookkeeping_agency" :key="item.code" :label="item.name" :value="item.code"></el-option>
              </el-select>

              <!-- <span>联系方式来源：</span> -->
              <el-cascader style="margin-right:16px" clearable placeholder="联系方式来源" v-model="contactChannel" :props="optionProps" :options="contactChannelArr" :show-all-levels="false" filterable
                @change="changeUnlockList"></el-cascader>

            </el-row>

          </div>
          <div :class="['operationBtn',hideFlag?'operationExpen':'']">
            <!-- <el-button type="dialog-confirm" size="small" class="ml-16" @click="clickReset">重置</el-button> -->
            <el-button class="packUp" type="text" @click="packUP">{{hideFlag?'收起':'展开'}}</el-button>
          </div>
          <!-- <div class="unlock-input-search">
            <el-input placeholder="请输入企业名称" v-model="companyName" class="input-with-select" size="small" @keyup.enter.native="changeUnlockList" suffix-icon="el-icon-search" /> -->
          <!-- <span @click="changeUnlockList" class="search-btn"><i class="el-icon-search" />查询</span> -->
          <!-- <el-button type="primary" size="small" class="ml-10" @click="clickReset">重置</el-button>
          </div> -->
        </div>
      </div>
      <div class="unlock-filter fx-s-center" :style="{padding:(selectWidth == 46 ? '10px 0px 10px 30px' : '10px 0px 10px 8px')}">
        <el-checkbox label="全选" :indeterminate="isIndeterminate" v-model="parentSelectAll" @change="changeAllVal"></el-checkbox>
        <span class="filter-select">(已选 {{clueSelected.length}} 个)</span>
        <el-button class="filter-up" v-if="type !== 3 && (NODE_ENV !== 'erp-prod' && NODE_ENV !== 'erp')" :disabled="clueSelected.length==0?true:false" @click="CollectionBatch" type="text"><i
            class="iconfont icon-zhuanhuan"></i>批量转线索</el-button>
        <el-button class="filter-up" v-if="type !== 3" :disabled="clueSelected.length==0?true:false" @click="removeContactToTrash(1)" type="text"><i
            class="iconfont icon-huishouzhan"></i>批量回收站</el-button>
        <el-button class="filter-up" v-if="type !== 3" @click="batchCleaningNumber" type="text"><i class="iconfont cleaningIcon"></i>批量清洗手机号码</el-button>
        <el-button class="filter-up" v-if="type === 3" :disabled="clueSelected.length==0?true:false" @click="removeContactToTrash(2)" type="text"><i class="iconfont icon-huifu"></i>批量恢复</el-button>
        <el-button class="filter-up" v-if="type === 3" :disabled="clueSelected.length==0?true:false" @click="removeContactToTrash(3)" type="text"><i
            class="iconfont icon-huishouzhan"></i>批量删除</el-button>
        <div class="fx-full" />
        <template v-if="type===1">
          <el-tooltip class="item" effect="light" content="最多导出1000家公司信息" placement="left">
            <i class="mr-12 el-icon-warning export-warning" />
          </el-tooltip>
          <el-button :loading="exportLoading" @click="handleExportCommand" type="primary" size="small">导出</el-button>
        </template>

        <!-- <el-dropdown type="primary" @command="handleExportCommand">
          <el-button :loading="exportLoading" type="primary" size="small">导出</el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>导出全部</el-dropdown-item>
            <el-dropdown-item>导出选中</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown> -->
      </div>
      <div v-loading="loading">
        <div class="out-box">
          <div class="unlock-container" v-for="(item,index) in tableData" :key='type + index'>
            <unlock-list-table :selectWidth="selectWidth" :contactNameWidthFlag="contactNameWidthFlag" @getLoading="getLoading" ref="unlockListTable" :propItem="propItems(item)" :type="type"
              @unlockList="unlockList" :parentSelectAll="parentSelectAll"></unlock-list-table>
          </div>
          <div class="emptyBox" v-if="!tableData.length">
            <img src="@/assets/emptyBox.svg" width="200" alt="" srcset="">
            <p class="center">暂无数据</p>
          </div>
        </div>
        <paginationNew :pageSizes="[20,40, 100]" v-if="tableData.length>0" :maxPageNum="maxPageNum" :pageNum="pageNum" :pageSize="pageSize" @currentChange="handleCurrentChange"
          @sizeChange="handleSizeChange"></paginationNew>
      </div>
      <!-- <pagination v-if="tableData.length>0" :pageNum="pageNum" :pageSize="pageSize" :total="total" @currentChange="handleCurrentChange" /> -->
    </div>
    <!-- <div v-if="activeTabs==='second'" style="padding: 15px;">
      <videoList />
    </div> -->
    <robot />
    <right-float ref="rightFloat" :globalRfType="true"></right-float>
    <!-- 创建清洗任务弹框 -->
    <create-cleaning-task-dialog ref="createCleaningTaskDialog" />
  </div>
</template>

<script>
import paginationNew from '@/components/pagination-new'
import { getNowTime } from '@/base/global'
import Robot from '../components/robot'
import unlockListTable from '../components/unlockListTable.vue'
import { unlockListV3, contactSubmitV2, removeContactToTrash, contactRevocation, contactReset, exportUnlockListExcel, getUnlock } from '../api/index'
import { selectOptions } from '../api/newClueApi'
import { cleaningSusplus } from '@/views/clue/api/cleaningApi'
// import { contactSubmit } from '../api/newClueApi'
// import videoList from './videoList'
import RightFloat from '@/components/rightFloatBtn'
import CreateCleaningTaskDialog from '@/components/createCleaningTaskDialog'

export default {
  components: { unlockListTable, paginationNew, Robot, RightFloat, CreateCleaningTaskDialog },
  data() {
    return {
      nLoading: false,
      activeTabs: 'first',
      type: 1,
      options: [
        { value: null, label: '全部' },
        { value: 1, label: '手机' },
        { value: 2, label: '固话' },
        { value: 3, label: '邮箱' }
      ],
      selectDate: '',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now()
        },
        // onPick: ({ maxDate, minDate }) => {
        //   this.selectDate = minDate.getTime()
        //   if (maxDate) {
        //     this.selectDate = ''
        //   }
        // },
        // disabledDate: (time) => {
        //   if (this.selectDate !== '') {
        //     const one = 30 * 24 * 3600 * 1000
        //     const minTime = this.selectDate - one
        //     const maxTime = this.selectDate + one
        //     return time.getTime() < minTime || time.getTime() > maxTime
        //   }
        // },
        shortcuts: [{
          text: '今天',
          onClick(picker) {
            const start = new Date()
            const end = new Date()
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '昨天',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 1)
            end.setTime(end.getTime() - 3600 * 1000 * 24 * 1)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '过去7天',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      headTotal: 0, // 等会再打
      // total: 0,
      maxPageNum: 0,
      date: [],
      // date: [getNowTime(new Date() - 86400000 * 30), getNowTime(new Date())],
      contactStatus: '',
      contactSource: '', // 联系方式类型
      companyName: '',
      pageNum: 1,
      pageSize: 20,
      tableData: [],
      listData: [],
      loading: false,
      parentSelectAll: false,
      isIndeterminate: false,
      bookkeeping_agency: [],
      numStatus: '', // 是否疑似代理
      contact_key_person: [],
      isKeyContact: '', // 是否疑似KP  是否关键联系人
      contactChannelArr: [],
      contactChannel: '', // 联系方式来源
      state: '',//号码清洗结果
      optionProps: {
        value: 'value',
        label: 'label',
        children: 'childOption'
      },
      hideFlag: true, // 收起展开
      isFollow: '', // 跟进状态
      selectWidth: 46,
      contactNameWidthFlag: false,
      NODE_ENV: '',
      exportLoading: false,
    }
  },
  computed: {
    clueSelected() {
      return this.$store.state.user.unlockList
    },
    propItems(item) {
      return function (item) {
        item.infoList.forEach(list => {
          this.$set(list, 'focusType', false)
          this.$set(list, 'remarkInput', list.remark ? list.remark : '')
        })
        return item
      }
    }
  },
  watch: {
    clueSelected: {
      immediate: true,
      handler(val) {
        if (!val) return false
        // const currentTableData = this.getTableDataLength()
        if (val.length == 0) {
          this.parentSelectAll = false
          this.isIndeterminate = false
        } else if (val.length == this.listData.length) {
          this.parentSelectAll = true
          this.isIndeterminate = false
        } else {
          this.isIndeterminate = true
        }
      }
    }
  },
  beforeDestroy() {
    this.__messageDone?.close?.()
    // this.getPageWrapPadding()
  },
  mounted() {
    this.NODE_ENV = process.env.NODE_ENV
    if (document.body.clientWidth < 1550) {
      this.contactNameWidthFlag = true
    } else if (document.body.clientWidth < 1440) {
      this.selectWidth = 30
    }
    window.addEventListener('resize', () => {
      if (document.body.clientWidth < 1550) {
        this.contactNameWidthFlag = true
      } else {
        this.contactNameWidthFlag = false
      }
      if (document.body.clientWidth < 1440) {
        this.selectWidth = 30
      } else this.selectWidth = 46
    })
    // this.setPageWrapPadding()
    this.getUnlock()
    this.getSelectOptions()
    this.unlockList()

  },
  methods: {
    // 收起展开
    packUP() {
      this.hideFlag = !this.hideFlag
    },
    // 是否代理记账 是否疑似KP
    getUnlock() {
      getUnlock().then(res => {
        if (res.code == 200) {
          this.bookkeeping_agency = res.data.bookkeeping_agency
          this.contact_key_person = res.data.contact_key_person
        }
      })
    },
    // 联系方式来源
    getSelectOptions() {
      selectOptions({ id: 24 }).then(res => {
        if (res.code == 200) {
          this.contactChannelArr = res.data.optionVos
        }
      })
    },
    // 子组件loading
    getLoading(code) {
      this.nLoading = code
    },

    handleExportCommand() {
      this.reqExportUnlockListExcel()
    },
    reqExportUnlockListExcel() {
      this.exportLoading = true
      this.__messageDone = this.$message({ duration: 0, message: '正在导出中...', type: 'notice' })
      const params = this.getReqParams()
      // TODO: 待对接
      exportUnlockListExcel(params).then(res => {
        this.Global.downloadBlob(res.data, '解锁列表.xlsx')
      }).catch((err) => {
        console.log('exportUnlockListExcel:err', err)
      }).finally(() => {
        this.__messageDone?.close?.()
        this.__messageDone = null
        this.exportLoading = false
      })
    },
    clickTabs(val) {
      if (this.loading) return
      this.pageNum = 1
      this.type = val
      this.$store.state.user.unlockList = []
      this.unlockList()
    },
    clickTabs1(val) {
      // this.activeTabs = val
      // this.$store.state.user.unlockList = []
      // if (this.activeTabs === 'first') {
      //   this.unlockList()
      // }
    },
    getTableDataLength() {
      const arr = []
      this.tableData.forEach(v => {
        v.infoList.forEach(n => {
          arr.push(n)
        })
      })
      return arr
    },
    getReqParams(){
      return {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        contactSource: this.contactSource,
        contactStatus: this.contactStatus,
        type: this.type,
        startDate: this.date ? this.date[0] : '',
        endDate: this.date ? this.date[1] : '',
        companyName: this.companyName,
        numStatus: this.numStatus,
        isKeyContact: this.isKeyContact,
        contactChannel: this.contactChannel.slice(-1).toString(),
        isFollow: this.isFollow,
        state: this.state
      }
    },
    unlockList(val) {
      // 筛选日期是否选中
      // if (!this.date) {
      //   this.$message.warning('请选择解锁日期')
      //   return
      // }
      if (val) {
        this.pageNum = 1
      }
      this.loading = true
      const params = this.getReqParams()
      // 无等会再打功能
      // contactCallLaterCount(params).then(res => {
      //   this.headTotal = res.data
      // })
      unlockListV3(params).then(res => {
        if (res.data.unlockVOS) {
          const recordItem = res.data.unlockVOS
          const index = recordItem.findIndex(item => item.infoList && item.infoList.length > 0)
          for (let i = 0; i < recordItem.length; i++) {
            // if (i == index) {
            //   this.$set(recordItem[i], 'collapse', true)
            // } else {
            //   this.$set(recordItem[i], 'collapse', false)
            // }
            this.$set(recordItem[i], 'collapse', true)
            if (recordItem[i].infoList && recordItem[i].infoList.length) {
              for (let j = 0; j < recordItem[i].infoList.length; j++) {
                this.$set(recordItem[i].infoList[j], 'infoId', `${i}_${j}`)
                this.$set(recordItem[i].infoList[j], 'checked', false)

                this.$set(recordItem[i].infoList[j], 'lineThrough', false)
                this.$set(recordItem[i].infoList[j], 'marksTagVal', '')
                this.$set(recordItem[i].infoList[j], 'marksInput', '')
              }
            }
          }
        }
        this.tableData = res.data.unlockVOS
        this.listData = []
        this.tableData.forEach(e => {
          this.listData = this.listData.concat(e.infoList)
        })
        this.pageNum = res.data.pageNum
        this.maxPageNum = res.data.maxPageNum
        // this.total = res.data.total
        this.loading = false
        this.$store.state.user.unlockList = []
      }).catch(e => {
        this.loading = false
      })
    },
    clickReset() {
      this.pageNum = 1
      this.isFollow = ''
      this.contactSource = ''
      this.contactStatus = ''
      this.companyName = ''
      this.date = []
      // this.date = [getNowTime(new Date() - 86400000 * 30), getNowTime(new Date())]
      this.numStatus = ''
      this.isKeyContact = ''
      this.contactChannel = ''
      this.state = ''
      this.unlockList()
    },
    changeUnlockList() {
      this.pageNum = 1
      this.unlockList()
    },
    handleSizeChange(val) {
      console.log(val)
      this.parentSelectAll = false
      this.pageNum = 1
      this.pageSize = val
      this.unlockList()
    },
    handleCurrentChange(val) {
      console.log(val)
      this.parentSelectAll = false
      this.pageNum = val
      this.unlockList()
    },
    // 全选
    changeAllVal() {
      // 过滤 已领取过的线索
      var selectList = []
      if (this.parentSelectAll) {
        this.tableData.forEach(m => {
          m.infoList.forEach(o => {
            o.checked = true
            selectList.push(o)
          })
        })
        this.$store.state.user.unlockList = selectList
      } else {
        this.$store.state.user.unlockList = []
      }
    },
    removeContactToTrash(sign) {
      const params = { contactInfoList: {} }
      params.contactInfoList = this.clueSelected.map(item => {
        return {
          companyName: item.companyName,
          hid: item.hid,
          isCompany: 0,
          contacts: [{
            source: JSON.stringify(item.sources),
            contactInfo: item.content,
            contactName: item.contactName,
            type: item.type,
            isTurnClue: item.isTurnClue
          }]
        }
      })
      this.nLoading = true
      if (sign === 1) {
        removeContactToTrash(params).then(res => {
          this.nLoading = false
          this.$message.success('回收成功')
          this.pageNum = 1
          this.unlockList()
        }).catch(err => {
          this.nLoading = false
        })
      }
      if (sign === 2) {
        contactRevocation(params).then(res => {
          this.nLoading = false
          this.$message.success('恢复成功')
          this.pageNum = 1
          this.unlockList()
        }).catch(err => {
          this.nLoading = false
        })
      }
      if (sign === 3) {
        contactReset(params).then(res => {
          this.nLoading = false
          this.$message.success('删除成功')
          this.pageNum = 1
          this.unlockList()
        }).catch(err => {
          this.nLoading = false
        })
      }
    },
    async CollectionBatch() {
      this.nLoading = true
      const params = { contactInfoList: {} }
      params.contactInfoList = this.clueSelected.map(item => {
        return {
          companyName: item.companyName,
          hid: item.hid,
          contacts: [{
            source: JSON.stringify(item.sources),
            contactInfo: item.content,
            contactName: item.contactName,
            type: item.type,
            isTurnClue: item.isTurnClue
          }]
        }
      })
      try {
        const { code } = await contactSubmitV2(params)
        this.nLoading = false
        if (code === 200) {
          this.$message.success('领取成功')
          this.unlockList()
        }
      } catch (err) {
        this.nLoading = false
      }
    },
    async batchCleaningNumber() {
      let num = 0
      const res = await cleaningSusplus()
      if (res.code == 200) {
        if (res.data) {
          num = res.data
        }
      }
      if (num <= 0) {
        this.$message.warning('无清洗权益')
        return false
      }
      // if(this.tableData.length == 0){
      //   this.$message.warning('无解锁企业')
      //   return false
      // }
      let arrMobile = []
      if (this.clueSelected.length) {
        this.clueSelected.forEach(v => {
          if ((v.type == 1 && v.state == 100) || (v.type == 1 && (v.state != 100 && v.overLimit))) {
            arrMobile.push(v)
          }
        })
      }
      let flag = this.clueSelected.length ? true : false
      if (arrMobile.length == 0 && flag) {
        this.$message.warning('请选择未检测手机号')
        return false
      }
      this.$refs.createCleaningTaskDialog.iniFun(flag, arrMobile)
    },

  }
}
</script>

<style lang="scss" scoped>
.packUp {
  margin-left: 16px;
}
.tabs-head {
  background: #fff;
  border-radius: 4px;
  padding: 0 24px;
  box-sizing: border-box;
  box-shadow: 0px 1px 5px 0px rgba(38, 38, 38, 0.1);
}
.div-tabs {
  height: 48px;
  line-height: 53px;
  border-bottom: 1px solid #f2f2f2;
  margin-bottom: 16px;
  .is-tabs {
    border-bottom: 2px solid #5088ff;
    font-weight: bold;
  }
  span {
    display: inline-block;
    // width: 120px;
    text-align: center;
    height: 100%;
    cursor: pointer;
    height: calc(100% + 1px);
    position: relative;
    top: 0px;
    padding: 0 16px;
    box-sizing: border-box;
    // font-weight: bold;
    color: #333333;
    font-size: 15px;
  }
}
.unlock-head {
  padding: 0px 0 6px 0;
  box-sizing: border-box;
  display: flex;
  justify-content: left;
  .input-with-select {
    // width: 257px;
    width: 208px;
  }
  .el-date-editor {
    width: 240px;
  }
  .el-select {
    width: 170px;
  }
}
.unlock-filter {
  padding: 10px 24px;
  box-sizing: border-box;
  .filter-select {
    padding: 0 0 0 15px;
    box-sizing: border-box;
  }
  .filter-up {
    margin-left: 24px;
    // cursor: pointer;
    border: none;
    .el-icon-sort {
      margin-right: 5px;
    }

    i {
      margin-right: 2px;
      &.icon-huishouzhan {
        margin-right: 0;
      }
      &.icon-zhuanhuan {
        font-size: 20px;
        vertical-align: middle;
        display: inline-block;
      }
    }
    .cleaningIcon {
      background-image: url("~@/assets/cleaning-svg.svg");
      width: 20px;
      height: 20px;
      display: inline-block;
      vertical-align: bottom;
    }
  }
}
.unlock-container {
  background: #fff;
  border-radius: 4px;
  box-shadow: 0px 1px 5px 0px rgba(38, 38, 38, 0.1);
  margin-bottom: 16px;
  /deep/ .container-head {
    border: none;
  }
  &:nth-last-of-type(1) {
    margin-bottom: 0;
  }
}

.emptyBox {
  width: 100%;
  text-align: center;
  padding: 115px;
  img {
    width: 64px;
  }
  p {
    color: #aaa;
  }
}

.unlock-input-search {
  display: flex;
  .search-btn {
    background: #4f7afd;
    color: #fff;
    border-radius: 0px 3px 3px 0px;
    padding: 0 15px;
    outline: none;
    height: 40px;
    line-height: 40px;
    font-size: inherit;
    border: 1px solid #4f7afd;
    cursor: pointer;
    .el-icon-search {
      margin-right: 5px;
      font-size: 18px;
      position: relative;
      top: 2px;
    }
  }
  /deep/ .el-input__inner {
    border-radius: 4px 0px 0px 4px;
  }
}
.unlock-head {
  .mr-16 {
    margin-right: 8px;
  }
  .el-button--small {
    height: 36px;
    // line-height: 36px;
    padding-top: 0;
    padding-bottom: 0;
  }
}

::v-deep {
  .searchBtn {
    position: relative;
    img {
      position: absolute;
      right: 11px;
      top: 0;
      bottom: 0;
      margin: auto;
      cursor: pointer;
    }
  }
  .el-range-editor {
    .el-range-input {
      padding-top: 2px;
      &:nth-of-type(2) {
        text-align: right;
      }
    }
  }
  .input-with-select {
    .el-input__inner {
      position: relative;
      // background: url('~@/assets/gbIcon/search_icon.png') no-repeat right;
      background-origin: content-box;
    }
  }
  .el-range-editor--small.el-input__inner {
    height: 36px;
    &:focus,
    &:hover {
      box-shadow: none;
      border-color: #e8e8f0;
    }
  }
  .el-range-editor.is-active {
    box-shadow: none;
  }
  .el-input--small .el-input__inner {
    height: 36px;
    line-height: 36px;
    &:focus,
    &:hover {
      box-shadow: none;
      border-color: #e8e8f0;
    }
  }
  .el-range-editor .el-range-input {
    width: 84px;
  }
  .el-range-editor--small .el-range-separator {
    line-height: 34px;
  }
  .unlock-head {
    .el-date-editor .el-range__close-icon {
      color: #b4bccc;
    }
    .el-input__icon:after {
      color: #b4bccc;
    }
    input {
      font-size: 14px;
    }
    input::-webkit-input-placeholder {
      color: #bfbfbf;
      font-size: 14px;
    }
    input::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color: #bfbfbf;
      font-size: 14px;
    }
    input:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      color: #bfbfbf;
      font-size: 14px;
    }
    input:-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #bfbfbf;
      font-size: 14px;
    }
    .el-range-input::-webkit-input-placeholder {
      color: #bfbfbf;
    }
    .el-range-input::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color: #bfbfbf;
    }
    .el-range-input:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      color: #bfbfbf;
    }
    .el-range-input:-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #bfbfbf;
    }
    .el-range-editor--small .el-range__icon,
    .el-range-editor--small .el-range__close-icon {
      line-height: 34px !important;
    }
  }
  .unlock-filter {
    .unlock-filter {
      span {
        color: #5088ff;
      }
    }
    .icon-huishouzhan {
      &::before {
        font-size: 20px;
        vertical-align: bottom;
        display: inline-block;
      }
    }
    .icon-huifu {
      &::before {
        font-size: 20px;
        vertical-align: middle;
        display: inline-block;
      }
    }
  }
  .el-select .el-input.is-focus .el-input__inner {
    box-shadow: none;
  }
  .el-range-editor.el-input__inner:focus,
  .el-cascader .el-input.is-focus .el-input__inner {
    box-shadow: none !important;
  }
  .el-cascader .el-input .el-input__inner:focus {
    border-color: #e8e8f0;
    box-shadow: none;
  }
  .el-cascader .el-input .el-input__inner:hover {
    border-color: #e8e8f0;
  }
  .pagination {
    padding: 24px 0;
  }
  .unlock-head .input-with-select {
    border: 1px solid #e8e8f0;
    border-radius: 4px;
  }
  .searchBtn {
    .el-input__inner {
      border: none;
      max-width: 236px;
      padding-right: 30px;
      box-sizing: border-box;
    }
  }
}
::v-deep {
  .operationBtn.operationExpen {
    position: relative;
    .el-button {
      position: absolute;
      // bottom: 0;
    }
  }
}

@media screen and (max-width: 1550px) {
  .unlock-head .el-select {
    // width: 133px;
    width: 164px;
  }
  .sort-condition .el-row:nth-last-of-type(1) .el-select {
    // width: 193px;
    width: 160px;
  }
  .el-cascader {
    // width: 120px;
    width: 137px;
  }
}
@media screen and (max-width: 1450px) {
  .unlock-head .el-select {
    width: 152px;
  }
}
@media screen and (max-width: 1439px) {
  .unlock-head .el-button--small {
    margin-left: 6px;
  }
  .unlock-head .el-select {
    // width: 103px;
    width: 127px;
  }
  .unlock-head .input-with-select {
    width: 170px;
  }
  .sort-condition {
    .el-select.isAgentA {
      width: 140px !important;
    }
  }
  .operationBtn.operationExpen .el-button {
    margin-left: 8px;
  }
}
@media screen and (max-width: 1336px) {
  .unlock-head .mr-16 {
    margin-right: 8px;
  }
  .sort-condition .el-row .el-select.isKeyContact {
    width: 130px;
  }
}

.export-warning {
  font-size: 16px;
  color: #ED6826;
  cursor: pointer;
}
</style>
